import React, { useEffect, useContext, Fragment, useState } from "react";
import SettingsContext from "../../context/settings/settingsContext";
import AuthContext from "../../context/auth/authContext";
import { useNavigate } from "react-router-dom";
import { useForm, Controller, useWatch } from "react-hook-form";
import { Modal, Tabs, Switch, message } from "antd";
import axios from "axios";

const defaultValues = {};
const SmartBuilderSettings = () => {
    const settingsContext = useContext(SettingsContext);
    const { settings, getSettings, updateSettings } = settingsContext;

    const authContext = useContext(AuthContext);
    const { user, loadUser } = authContext;

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    // Form state variables
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [streetAddress, setStreetAddress] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [zipCode, setZipCode] = useState('');
    const [vendorName, setVendorName] = useState('');
    const [vendorEmail, setVendorEmail] = useState('');
    const [vendorStreetAddress, setVendorStreetAddress] = useState('');
    const [vendorCity, setVendorCity] = useState('');
    const [vendorState, setVendorState] = useState('');
    const [vendorZipCode, setVendorZipCode] = useState('');
    const [strCustomerID, setStrCustomerID] = useState('');
    const [strWarehouseID, setStrWarehouseID] = useState('');
    const [strDepartmentID, setStrDepartmentID] = useState('');
    const [smartBuilderUsername, setSmartBuilderUsername] = useState('');
    const [smartBuilderPassword, setSmartBuilderPassword] = useState('');

    // Load settings when component mounts
    useEffect(() => {
        getSettings();
    }, []); // Only run once on mount

    // Update form data when settings or user changes
    useEffect(() => {
        if (settings) {
            setName(settings.name || '');
            setEmail(settings.email || '');
            setStreetAddress(settings.streetAddress || '');
            setCity(settings.city || '');
            setState(settings.state || '');
            setZipCode(settings.zipCode || '');
            setVendorName(settings.vendorName || '');
            setVendorEmail(settings.vendorEmail || '');
            setVendorStreetAddress(settings.vendorStreetAddress || '');
            setVendorCity(settings.vendorCity || '');
            setVendorState(settings.vendorState || '');
            setVendorZipCode(settings.vendorZipCode || '');
            setStrCustomerID(settings.strCustomerID || '');
            setStrWarehouseID(settings.strWarehouseID || '');
            setStrDepartmentID(settings.strDepartmentID || '');
        }
        if (user) {
            setSmartBuilderUsername(user.smartBuilderUsername || '');
            setSmartBuilderPassword(user.smartBuilderPassword || '');
        }
    }, [settings, user]); // Only update when settings or user changes

    const onSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);

            // Update SmartBuilder credentials (user data)
            const userUpdateData = {
                smartBuilderUsername,
                smartBuilderPassword
            };

            await axios.put(`/api/users/update/${user._id}`, userUpdateData);
            await loadUser();

            // Update settings
            const settingsUpdateData = {
                name,
                email,
                streetAddress,
                city,
                state,
                zipCode,
                vendorName,
                vendorEmail,
                vendorStreetAddress,
                vendorCity,
                vendorState,
                vendorZipCode,
                strCustomerID,
                strWarehouseID,
                strDepartmentID
            };

            await updateSettings(settingsUpdateData);
            await getSettings();

            message.success('Settings updated successfully');
            setTimeout(() => {
                navigate(-1);
            }, 1000);
        } catch (err) {
            console.error('Update error:', err);
            message.error('Failed to update settings');
        } finally {
            setLoading(false);
        }
    };

    const setExit = () => {
        navigate(-1);
    };

    const handlePasswordToggle = (checked) => {
        setShowPassword(checked);
        if (checked && user) {
            setSmartBuilderPassword(user.smartBuilderPassword);
        }
        if (!checked) {
            setSmartBuilderPassword('');
        }
    };

    return (
        <Fragment>
            <div className="container-fluid pb-4">
                <div className="row">
                    <div className="col-md-12">
                        <button className="float-end mb-2 mt-2 btn btn-outline-danger" onClick={() => setExit()}>
                            Back
                        </button>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-12">
                        <h4 className="text-center">SmartBuild & FCM Settings</h4>
                    </div>
                </div>
                <div className="row">
                    <form onSubmit={onSubmit}>
                        <div className="border settingsform" style={{ borderRadius: "5px" }}>
                            <Tabs defaultActiveKey="myInfo">
                                <Tabs.TabPane tab="My Information" key="myInfo">
                                    <div className="col-md-12">
                                        <div className="row mb-2 mt-2">
                                            <div className="col-md-5">
                                                <h4 className="text-center">My Information</h4>
                                                <div className="form-group">
                                                    <label>Name</label>
                                                    <input
                                                        className="form-control inputbg"
                                                        value={name}
                                                        onChange={(e) => setName(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Email</label>
                                                    <input
                                                        className="form-control inputbg"
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Street Address</label>
                                                    <input
                                                        className="form-control inputbg"
                                                        value={streetAddress}
                                                        onChange={(e) => setStreetAddress(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>City</label>
                                                    <input
                                                        className="form-control inputbg"
                                                        value={city}
                                                        onChange={(e) => setCity(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>State</label>
                                                    <input
                                                        className="form-control inputbg"
                                                        value={state}
                                                        onChange={(e) => setState(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Zip Code</label>
                                                    <input
                                                        className="form-control inputbg"
                                                        value={zipCode}
                                                        onChange={(e) => setZipCode(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-2"></div>
                                            <div className="col-md-5">
                                                <h4 className="text-center mt-4">Vendor Information</h4>
                                                <div className="form-group">
                                                    <label>Vendor Name</label>
                                                    <input
                                                        className="form-control inputbg"
                                                        value={vendorName}
                                                        onChange={(e) => setVendorName(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Vendor Email</label>
                                                    <input
                                                        className="form-control inputbg"
                                                        value={vendorEmail}
                                                        onChange={(e) => setVendorEmail(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Vendor Street Address</label>
                                                    <input
                                                        className="form-control inputbg"
                                                        value={vendorStreetAddress}
                                                        onChange={(e) => setVendorStreetAddress(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Vendor City</label>
                                                    <input
                                                        className="form-control inputbg"
                                                        value={vendorCity}
                                                        onChange={(e) => setVendorCity(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Vendor State</label>
                                                    <input
                                                        className="form-control inputbg"
                                                        value={vendorState}
                                                        onChange={(e) => setVendorState(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Vendor Zip Code</label>
                                                    <input
                                                        className="form-control inputbg"
                                                        value={vendorZipCode}
                                                        onChange={(e) => setVendorZipCode(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Tabs.TabPane>

                                <Tabs.TabPane tab="SmartBuild" key="smartbuilder">
                                    <div className="col-md-12">
                                        <div className="row mb-2 mt-2">
                                            <div className="col-md-6">
                                                <h4 className="text-center">SmartBuild Settings</h4>
                                                <div className="form-group">
                                                    <label>SmartBuild Username</label>
                                                    <input
                                                        className="form-control inputbg"
                                                        value={smartBuilderUsername}
                                                        onChange={(e) => setSmartBuilderUsername(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Show Password</label>
                                                    <Switch
                                                        checked={showPassword}
                                                        onChange={handlePasswordToggle}
                                                        checkedChildren="Hide Password"
                                                        unCheckedChildren="Show Password"
                                                    />
                                                </div>
                                                {showPassword && (
                                                    <div className="form-group">
                                                        <label>SmartBuild Password</label>
                                                        <input
                                                            className="form-control inputbg"
                                                            value={smartBuilderPassword}
                                                            onChange={(e) => setSmartBuilderPassword(e.target.value)}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </Tabs.TabPane>

                                <Tabs.TabPane tab="FCM" key="fcm">
                                    <div className="col-md-12">
                                        <div className="row mb-2 mt-2">
                                            <div className="col-md-6">
                                                <h4 className="text-center">FCM Settings</h4>
                                                <div className="form-group">
                                                    <label>Customer ID</label>
                                                    <input
                                                        className="form-control inputbg"
                                                        value={strCustomerID}
                                                        onChange={(e) => setStrCustomerID(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Warehouse ID</label>
                                                    <input
                                                        className="form-control inputbg"
                                                        value={strWarehouseID}
                                                        onChange={(e) => setStrWarehouseID(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Department ID</label>
                                                    <input
                                                        className="form-control inputbg"
                                                        value={strDepartmentID}
                                                        onChange={(e) => setStrDepartmentID(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Tabs.TabPane>
                            </Tabs>

                            <div className="form-group mt-4">
                                <button
                                    className="btn btn-prime float-end"
                                    type="submit"
                                    disabled={loading}
                                >
                                    {loading ? 'Saving...' : 'Save'}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </Fragment>
    );
};

export default SmartBuilderSettings; 